import Vue from 'vue'
import bearer from './drivers/alterna-bearer.js'
import router from '../../router'

Vue.router = router

Vue.use(require('@websanova/vue-auth'), {
  auth: bearer,
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  loginData: {url: 'login', method: 'POST', redirect: '/', fetchUser: true},
  // eslint-disable-next-line no-undef
  refreshData: {url: `${new URL('connect/token', config ? config.VUE_APP_IDENTITY_SERVER_URI || process.env.VUE_APP_IDENTITY_SERVER_URI : process.env.VUE_APP_IDENTITY_SERVER_URI).href}`, method: 'POST', enabled: false, interval: 60},
  // eslint-disable-next-line no-undef
  fetchData: {url: `${new URL('connect/userinfo', config ? config.VUE_APP_IDENTITY_SERVER_URI || process.env.VUE_APP_IDENTITY_SERVER_URI : process.env.VUE_APP_IDENTITY_SERVER_URI).href}`, method: 'GET', enabled: true},
  notFoundRedirect: {path: '/'},
  tokenStore: ['localStorage'],
  tokenDefaultName: 'alterna_ai_token',
  parseUserData: parseUserData,
  rolesVar: 'AuthScope',
  tokenExpired: tokenExpired,
  refreshPerform: refreshPerform
})

function parseUserData (data) {
  return data
}

function tokenExpired () {
  console.log('token expired')
  return true
}

function refreshPerform (data) {
  console.log(data)
  console.log('refresh perform')
  data.success.call(this)
  return true
}
